import styled from 'styled-components';

export const FallbackWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  min-height: 55px;
  padding: 0 20px;
  background-color: #ffffff;
  border-bottom: 5px solid #f5f5f5;
`;

export const LogoLink = styled.a`
  display: block;
  width: 172px;
  height: 32px;
  @media (max-width: 480px) {
    width: 95px;
    height: 18px;
  }
  img {
    display: block;
    max-width: 100%;
  }
`;

export const ProductLabel = styled.span`
  font-size: 20px;
  font-weight: 400;
  color: #3e3e3e;
  margin-left: 5px;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  padding-left: 5px;
  position: relative;
  padding-top: 3px;
  flex: 1;
`;

export const Mid = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  padding-top: 3px;
`;

export const Right = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-content: space-between;
  align-items: center;
  padding-top: 3px;
  button {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const StyledMenu = styled.div`
  #fallback-menu-toggle {
    display: none;
  }

  .menu-button {
    display: block;
    margin-right: 15px;
    color: #333;
    cursor: pointer;
    font-size: 28px;
    font-weight: 400;
  }

  .menu-content {
    position: absolute;
    width: 200px;
    left: 0px;
    display: none;
    list-style: none;
    padding: 0;
    margin: 0;
    background-color: #f4f4f4;
    border: 1px solid #d1d1d1;
    z-index: 99;
    font-size: 14px;
  }

  .menu-content li a {
    display: block;
    padding: 6px;
    text-decoration: none;
    color: #333;
  }

  .menu-content li a:hover {
    background-color: #ddd;
  }

  .menu-content li {
    &:not(:last-child) {
      border-bottom: 1px solid #d1d1d1;
    }
  }

  #fallback-menu-toggle:checked ~ .menu-content {
    display: block;
  }
`;
